"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistoricalSeerRatings = exports.getLastGoodSeerRating = exports.getUserHubRelationsByUser = exports.getSensorUsageRollup = exports.getSeerRating = exports.getHvacFilterOrderStatus = exports.getHVACFilterStatus = exports.listServiceCompanies = exports.getAirQuality = exports.getServiceCompany = exports.listHomeownersWithHubs = exports.listCustomersOverview = exports.listCustomers = exports.getCustomer = exports.getServiceRequestStatusCounts = exports.getServiceRequestsByAlert = exports.getServiceRequestsBySensor = exports.getServiceRequestsByHub = exports.getServiceRequestsByCustomer = exports.listServiceRequests = exports.getServiceRequest = exports.getSensorAlertsByHub = exports.getSensorAlertsBySensor = exports.getSensorAlert = exports.getSensorAlertStatusCounts = exports.listSensorAlerts = exports.getSensorHistoricalState = exports.getSensorCurrentState = exports.getSensorEventsByHub = exports.getSensorEventsBySensor = exports.getSensorsByHub = exports.getSensorsByGroupId = exports.getSensor = exports.listSensors = exports.listHubs = exports.getHub = void 0;
exports.getHub = `
  query GetHub($id: ID!) {
    getHub(id: $id) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      street
      city
      state
      zip
      logoUrl
      date
      time
      timezone
    }
  }
`;
exports.listHubs = `
  query ListHubs($limit: Int, $nextToken: String) {
    listHubs(limit: $limit, nextToken: $nextToken) {
      id
      serialNumber
      macAddress
      name
      status
      latitude
      longitude
      config
      street
      city
      state
      zip
      logoUrl
      date
      time
      timezone
    }
  }
`;
exports.listSensors = `
  query ListSensors($limit: Int, $nextToken: String) {
    listSensors(limit: $limit, nextToken: $nextToken) {
      id
      hubId
      serialNumber
      dsk
      type
      version
      name
      location
      sublocation
      status
      lastReported
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
    }
  }
`;
exports.getSensor = `
  query GetSensor($id: ID!) {
    getSensor(id: $id) {
      id
      hubId
      serialNumber
      dsk
      type
      version
      name
      location
      sublocation
      status
      lastReported
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
      flowMultiplier
      seerMid
      seerMax
    }
  }
`;
exports.getSensorsByGroupId = `
  query GetSensorsByGroupId($groupId: ID!, $limit: Int, $nextToken: String) {
    getSensorsByGroupId(groupId: $groupId, limit: $limit, nextToken: $nextToken) {
      id
      hubId
      serialNumber
      dsk
      type
      version
      name
      location
      sublocation
      status
      lastReported
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
      flowMultiplier
      seerMid
      seerMax
    }
  }
`;
exports.getSensorsByHub = `
  query GetSensorsByHub($hubId: ID!, $limit: Int, $nextToken: String) {
    getSensorsByHub(hubId: $hubId, limit: $limit, nextToken: $nextToken) {
      id
      hubId
      serialNumber
      dsk
      type
      version
      name
      location
      sublocation
      status
      lastReported
      branchCircuits {
        circuitNumber
        breakerNumber
        powerMonitorInputNumber
        breakerType
        location
        sublocation
        underCurrentAlert
        overCurrentAlert
        underCurrentAlertCustomAmps
        overCurrentAlertCustomAmps
      }
      groupId
      sensorGroupConfiguration {
        indoor
        metadata
      }
      flowMultiplier
      seerMid
      seerMax
    }
  }
`;
exports.getSensorEventsBySensor = `
  query GetSensorEventsBySensor($sensorId: ID!, $limit: Int, $nextToken: String) {
    getSensorEventsBySensor(sensorId: $sensorId, limit: $limit, nextToken: $nextToken) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.getSensorEventsByHub = `
  query GetSensorEventsByHub($hubId: ID!, $limit: Int, $nextToken: String) {
    getSensorEventsByHub(hubId: $hubId, limit: $limit, nextToken: $nextToken) {
      id
      timestamp
      sensorId
      hubId
      eventType
      value
      values
      metadata
    }
  }
`;
exports.getSensorCurrentState = `
  query GetSensorCurrentState($sensorId: ID!) {
    getSensorCurrentState(sensorId: $sensorId) {
      sensorId
      hubId
      timestamp
      value
      metadata
    }
  }
`;
exports.getSensorHistoricalState = `
  query GetSensorHistoricalState(
    $sensorId: ID!
    $startTime: Float!
    $endTime: Float!
    $rollup: Float!
  ) {
    getSensorHistoricalState(
      sensorId: $sensorId
      startTime: $startTime
      endTime: $endTime
      rollup: $rollup
    ) {
      sensorId
      hubId
      timestamp
      value
      values
      metadata
    }
  }
`;
exports.listSensorAlerts = `
  query ListSensorAlerts(
    $limit: Int
    $nextToken: String
    $customerId: String
    $alertType: String
    $severity: String
    $status: String
    $isAcknowledged: Boolean
  ) {
    listSensorAlerts(
      limit: $limit
      nextToken: $nextToken
      customerId: $customerId
      alertType: $alertType
      severity: $severity
      status: $status
      isAcknowledged: $isAcknowledged
    ) {
      items {
        id
        timestamp
        sensorId
        hubId
        customerId
        alertType
        severity
        message
        value
        metadata
        status
        acknowledgedAt
        acknowledgedBy
      }
      nextToken
    }
  }
`;
exports.getSensorAlertStatusCounts = `
  query GetSensorAlertStatusCounts($customerId: String, $alertType: String, $severity: String) {
    getSensorAlertStatusCounts(
      customerId: $customerId
      alertType: $alertType
      severity: $severity
    ) {
      activeCount
      clearedCount
    }
  }
`;
exports.getSensorAlert = `
  query GetSensorAlert($id: ID!) {
    getSensorAlert(id: $id) {
      id
      timestamp
      sensorId
      sensor {
        id
        name
        type
        location
        sublocation
      }
      hubId
      hub {
        id
        name
        latitude
        longitude
      }
      customerId
      customer {
        id
        name
        email
        phone
        address
        city
        state
        zipCode
        country
      }
      serviceRequest {
        id
        serviceCompanyId
      }
      serviceCompany {
        id
        name
        email
        phone
        address
        city
        state
        zipCode
        logoUrl
        website
      }
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.getSensorAlertsBySensor = `
  query GetSensorAlertsBySensor($sensorId: ID!, $limit: Int, $nextToken: String) {
    getSensorAlertsBySensor(sensorId: $sensorId, limit: $limit, nextToken: $nextToken) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.getSensorAlertsByHub = `
  query GetSensorAlertsByHub($hubId: ID!, $limit: Int, $nextToken: String) {
    getSensorAlertsByHub(hubId: $hubId, limit: $limit, nextToken: $nextToken) {
      id
      timestamp
      sensorId
      hubId
      alertType
      severity
      message
      value
      metadata
      status
      acknowledgedAt
      acknowledgedBy
    }
  }
`;
exports.getServiceRequest = `
  query GetServiceRequest($id: ID!) {
    getServiceRequest(id: $id) {
      id
      customerId
      customer {
        id
        name
        email
        phone
      }
      hubId
      hub {
        id
        name
        serialNumber
      }
      sensorId
      sensor {
        id
        name
        type
      }
      alertId
      alert {
        id
        alertType
        severity
        message
        status
      }
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
      createdAt
      updatedAt
      customerComplaint
      customerNotes
      notes
      potentialCause
      accessInstructions
      additionalNotes
      serviceCompanyId
      serviceCompany {
        id
        name
        email
        phone
      }
      serviceCompanyName
      technicianName
      deviceLocation
      roomType
    }
  }
`;
exports.listServiceRequests = `
  query ListServiceRequests(
    $limit: Int
    $nextToken: String
    $customerId: String
    $serviceType: String
    $status: String
  ) {
    listServiceRequests(
      limit: $limit
      nextToken: $nextToken
      customerId: $customerId
      serviceType: $serviceType
      status: $status
    ) {
      items {
        id
        customerId
        hubId
        sensorId
        alertId
        alert {
          id
          timestamp
        }
        jobNumber
        serviceType
        reason
        status
        priority
        requestedAt
        scheduledAt
        completedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
exports.getServiceRequestsByCustomer = `
  query GetServiceRequestsByCustomer($customerId: ID!, $limit: Int, $nextToken: String) {
    getServiceRequestsByCustomer(customerId: $customerId, limit: $limit, nextToken: $nextToken) {
      id
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
    }
  }
`;
exports.getServiceRequestsByHub = `
  query GetServiceRequestsByHub($hubId: ID!, $limit: Int, $nextToken: String) {
    getServiceRequestsByHub(hubId: $hubId, limit: $limit, nextToken: $nextToken) {
      id
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
    }
  }
`;
exports.getServiceRequestsBySensor = `
  query GetServiceRequestsBySensor($sensorId: ID!, $limit: Int, $nextToken: String) {
    getServiceRequestsBySensor(sensorId: $sensorId, limit: $limit, nextToken: $nextToken) {
      id
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
    }
  }
`;
exports.getServiceRequestsByAlert = `
  query GetServiceRequestsByAlert($alertId: ID!, $limit: Int, $nextToken: String) {
    getServiceRequestsByAlert(alertId: $alertId, limit: $limit, nextToken: $nextToken) {
      id
      jobNumber
      serviceType
      reason
      status
      priority
      requestedAt
      scheduledAt
      completedAt
    }
  }
`;
exports.getServiceRequestStatusCounts = `
  query GetServiceRequestStatusCounts($customerId: String, $serviceType: String) {
    getServiceRequestStatusCounts(customerId: $customerId, serviceType: $serviceType) {
      open
      pending
      in_progress
      reschedule
      canceled
      closed
    }
  }
`;
exports.getCustomer = `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
      serviceRequests {
        id
        jobNumber
        serviceType
        status
        requestedAt
        completedAt
      }
    }
  }
`;
exports.listCustomers = `
  query ListCustomers($limit: Int, $nextToken: String) {
    listCustomers(limit: $limit, nextToken: $nextToken) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      country
      companyName
      createdAt
      updatedAt
    }
  }
`;
exports.listCustomersOverview = `
  query listCustomersOverview($text: String, $limit: Int, $nextToken: String) {
    listCustomersOverview(text: $text, limit: $limit, nextToken: $nextToken) {
      customer {
        id
        name
        email
        phone
        address
        city
        state
        zipCode
        country
        companyName
        createdAt
        updatedAt
      }
      sensorCount
      sensorTypes
      alertCount
      criticalAlertCount
    }
  }
`;
exports.listHomeownersWithHubs = `
  query listHomeownersWithHubs($text: String, $limit: Int, $nextToken: String) {
    listHomeownersWithHubs(text: $text, limit: $limit, nextToken: $nextToken) {
      customer {
        id
        name
        email
        phone
        address
        city
        state
        zipCode
        country
        companyName
        createdAt
        updatedAt
      }
      sensorCount
      sensorTypes
      alertCount
      criticalAlertCount
      sensorCoverageGaps
      hubs {
        id
        serialNumber
        macAddress
        name
        status
        latitude
        longitude
        street
        city
        state
        zip
      }
    }
  }
`;
exports.getServiceCompany = `
  query GetServiceCompany($id: ID!) {
    getServiceCompany(id: $id) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;
exports.getAirQuality = `
  query GetAirQuality($latitude: Float!, $longitude: Float!) {
    getAirQuality(latitude: $latitude, longitude: $longitude) {
      regionCode
      universalAqi {
        aqi
        aqiDisplay
        category
        categoryDisplay
        color {
          red
          green
          blue
        }
        dominantPollutant
      }
      localAqi {
        aqi
        aqiDisplay
        category
        categoryDisplay
        color {
          red
          green
          blue
        }
        dominantPollutant
      }
      dominantPollutant {
        code
        displayName
        fullName
        concentration {
          value
          units
        }
        additionalInfo {
          sources
          effects
        }
      }
      healthRecommendations {
        generalPopulation
        elderly
        lungDiseasePopulation
        heartDiseasePopulation
        athletes
        pregnantWomen
        children
      }
    }
  }
`;
exports.listServiceCompanies = `
  query ListServiceCompanies($limit: Int, $nextToken: String) {
    listServiceCompanies(limit: $limit, nextToken: $nextToken) {
      id
      name
      email
      phone
      address
      city
      state
      zipCode
      logoUrl
      website
      createdAt
      updatedAt
    }
  }
`;
exports.getHVACFilterStatus = `
  query GetHVACFilterStatus($sensorId: ID!) {
    getHVACFilterStatus(sensorId: $sensorId) {
      sensorId
      hubId
      calculatedAt
      filterStatus
      replacementTime
      status
      filterReplacementStatus
      thresholdCategory
      pressureDelta
      filterHealthPercentage
      peakLoadData
    }
  }
`;
exports.getHvacFilterOrderStatus = `
  query GetHvacFilterOrderStatus($sensorId: ID!, $hubId: ID!) {
    getHvacFilterOrderStatus(sensorId: $sensorId, hubId: $hubId) {
      sensorId
      hubId
      status
      hasServiceRequest
      hasFilterOrder
      serviceRequest {
        id
        jobNumber
        serviceType
        reason
        status
        priority
        requestedAt
        createdAt
        notes
      }
      filterOrder {
        id
        jobNumber
        serviceType
        reason
        status
        priority
        requestedAt
        createdAt
        notes
        additionalNotes
      }
      lastActionAt
      message
    }
  }
`;
exports.getSeerRating = `
  query GetSeerRating($hubId: ID!) {
    getSeerRating(hubId: $hubId) {
      hubId
      instantSeerRating
      lastMinuteSeerRating {
        coolingOutput
        powerWattHours
        seerValue
        runningDataPoints
        totalDataPoints
        avgFlow
        avgFlowRaw
        avgReturnTemp
        avgSupplyTemp
        avgReturnTempF
        avgSupplyTempF
        avgReturnHumidity
        avgSupplyHumidity
        deltaT
        avgReturnPressure
        avgSupplyPressure
        runningTimeSeconds
        runningTimePercentage
        latentCoolingOutput
        humidityRatioDifference
        airHandlerAvgAmperage
        condenserAvgAmperage
        combinedAvgAmperage
        airHandlerDataPoints
        condenserDataPoints
      }
      runningHourSeerRating {
        coolingOutput
        powerWattHours
        seerValue
        runningDataPoints
        totalDataPoints
        avgFlow
        avgFlowRaw
        avgReturnTemp
        avgSupplyTemp
        avgReturnTempF
        avgSupplyTempF
        avgReturnHumidity
        avgSupplyHumidity
        deltaT
        avgReturnPressure
        avgSupplyPressure
        runningTimeSeconds
        runningTimePercentage
        latentCoolingOutput
        humidityRatioDifference
        airHandlerAvgAmperage
        condenserAvgAmperage
        combinedAvgAmperage
        airHandlerDataPoints
        condenserDataPoints
      }
      previousHourRating {
        coolingOutput
        powerWattHours
        seerValue
        runningDataPoints
        totalDataPoints
        avgFlow
        avgFlowRaw
        avgReturnTemp
        avgSupplyTemp
        avgReturnTempF
        avgSupplyTempF
        avgReturnHumidity
        avgSupplyHumidity
        deltaT
        avgReturnPressure
        avgSupplyPressure
        runningTimeSeconds
        runningTimePercentage
        latentCoolingOutput
        humidityRatioDifference
        airHandlerAvgAmperage
        condenserAvgAmperage
        combinedAvgAmperage
        airHandlerDataPoints
        condenserDataPoints
      }
      powerTotal
      coolingOutput
      timestamp
      hvacRunning
    }
  }
`;
exports.getSensorUsageRollup = `
  query GetSensorUsageRollup(
    $sensorId: ID!
    $startDate: String!
    $endDate: String!
    $nextToken: String
  ) {
    getSensorUsageRollup(
      sensorId: $sensorId
      startDate: $startDate
      endDate: $endDate
      nextToken: $nextToken
    ) {
      items {
        sensorId
        date
        dateHour
        hour
        sensorType
        hubId
        totalDataPoints
        createdAt
        updatedAt
        powerUsageRollup {
          averageBranchCt1
          averageBranchCt2
          averageBranchCt3
          averageBranchCt4
          averageBranchCt5
          averageBranchCt6
          averageBranchCt7
          averageBranchCt8
          averageBranchCt9
          averageBranchCt10
          averageBranchCt11
          averageBranchCt12
          averageBranchCt13
          averageBranchCt14
          averageBranchCt15
          averageBranchCt16
          averageMainCt1
          averageMainCt2
          averageVt1
          averageVt2
        }
        airQualityRollup {
          avgTemperature
          minTemperature
          maxTemperature
          avgHumidity
          minHumidity
          maxHumidity
          avgIAQ
          minIAQ
          maxIAQ
          avgPM
          minPM
          maxPM
          avgPressure
          minPressure
          maxPressure
        }
        waterQualityRollup {
          avgEC
          minEC
          maxEC
        }
        leakDetectorRollup {
          avgTemperature
          minTemperature
          maxTemperature
          avgHumidity
          minHumidity
          maxHumidity
          leakDetected
          leakCount
          leakPercentage
        }
        hvacRollup {
          avgTemperature
          minTemperature
          maxTemperature
          avgHumidity
          minHumidity
          maxHumidity
          avgPressure
          minPressure
          maxPressure
          avgTc1
          minTc1
          maxTc1
          avgTc2
          minTc2
          maxTc2
        }
      }
      nextToken
    }
  }
`;
exports.getUserHubRelationsByUser = `
  query GetUserHubRelationsByUser($userId: String!) {
    getUserHubRelationsByUser(userId: $userId) {
      userId
      hubId
      relationship
      customerId
      customerName
      createdAt
      updatedAt
    }
  }
`;
exports.getLastGoodSeerRating = `
  query GetLastGoodSeerRating($hubId: ID!) {
    getLastGoodSeerRating(hubId: $hubId) {
      hubId
      seerValue
      timestamp
      calculatedAt
    }
  }
`;
exports.getHistoricalSeerRatings = `
  query GetHistoricalSeerRatings(
    $hubId: ID!
    $startTimestamp: Float
    $endTimestamp: Float
    $limit: Int
  ) {
    getHistoricalSeerRatings(
      hubId: $hubId
      startTimestamp: $startTimestamp
      endTimestamp: $endTimestamp
      limit: $limit
    ) {
      hubId
      seerValue
      timestamp
      calculatedAt
    }
  }
`;
